import type { PlanType } from 'ncp-api-supporter';
import moment from 'moment';

// 게시글 신규(N) 아이콘 노출 기간: 등록일로부터 +7일까지
export const NEW_BADGE_DURATION_DAYS = 7;

/** 게시글 등록일 기준 신규(N) 아이콘 노출 여부 (등록일 + 노출기간이 오늘 이후인지) */
export const isNewArticle = (publishedAt: string): boolean => {
  if (!publishedAt) return false;
  return moment(publishedAt).add(NEW_BADGE_DURATION_DAYS, 'days').isSameOrAfter(moment(), 'day');
};

const quickMenus = [
  {
    quickMenuNo: 1,
    menu: {menuUrl: '/product/addList'},
    menuNameLabel: '상품등록',
    icon: 'btn_product_add'
  },
  {
    quickMenuNo: 2,
    menu: {menuUrl: '/product/list'},
    menuNameLabel: '상품조회',
    icon: 'btn_product_lst'
  },
  {
    quickMenuNo: 3,
    menu: {menuUrl: '/order/list'},
    menuNameLabel: '주문조회',
    icon: 'btn_order_lst'
  },
  {
    quickMenuNo: 4,
    menu: {menuUrl: '/member/list'},
    menuNameLabel: '회원조회',
    icon: 'btn_member_lst'
  },
  {
    quickMenuNo: 5,
    menu: {menuUrl: '/promotion/coupon/addForm'},
    menuNameLabel: '쿠폰등록',
    icon: 'btn_promotion_add'
  },
  {
    quickMenuNo: 6,
    menu: {menuUrl: '/promotion/coupon/list'},
    menuNameLabel: '쿠폰조회',
    icon: 'btn_coupon_lst'
  },
  {
    quickMenuNo: 7,
    menu: {menuUrl: '/partner/list'},
    menuNameLabel: '파트너사조회',
    icon: 'btn_partner_lst'
  },
  {
    quickMenuNo: 8,
    menu: {menuUrl: '/board/notice'},
    menuNameLabel: '공지등록',
    icon: 'btn_notice_add'
  }
];

export const getQuickMenus = (plan: PlanType) => {
  switch (plan) {
    case 'STANDARD':
      return quickMenus.slice(0, -2);
    default:
      return quickMenus;
  }
};
